import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import asObject from 'utils/objects/asObject.util';

import { TRANSACTION_EMAIL_FAILURE, TRANSACTION_EMAIL_REQUEST, TRANSACTION_EMAIL_SUCCESS } from 'checkout/constants';

const DEFAULT = Object.freeze({
  isFetching: false,
  emailSent: null,
  response: null,
  authenticated: true,
  errorMessage: null,
});

const MAP = Object.freeze({
  [TRANSACTION_EMAIL_REQUEST]: (state) => ({
    ...state,
    isFetching: true,
    emailSent: null,
    response: state.response,
    errorMessage: null,
  }),
  [TRANSACTION_EMAIL_SUCCESS]: (state, action) => ({
    ...state,
    isFetching: false,
    emailSent: true,
    response: action.response,
    authenticated: action.authenticated || false,
  }),
  [TRANSACTION_EMAIL_FAILURE]: (state, action) => ({
    ...state,
    isFetching: false,
    emailSent: false,
    errorMessage: action.errorMessage,
  }),
});

const transactionEmailSend = (state, action) => (MAP[action && action.type] || alwaysSame)(state || { ...DEFAULT }, asObject(action));

// noinspection JSUnusedGlobalSymbols
export default transactionEmailSend;
